import { useHistory } from 'react-router'
import React, { useCallback } from 'react'

import { CommonContainerProps } from './index'

import { ClickableCrossDark } from 'components/Buttons/ClickableIcon'
import ProgressBar from 'components/EditPost/Progressbar'
import BackButton from 'components/Buttons/BackButton'
import GradientButton from 'components/Buttons/GradientButton'

import {
	Container,
	ProgressHeader,
	FooterContainer,
	HeaderText,
	Divider,
	ConfirmButton,
	ChildContainer
} from './EditPostContainer.styles'

export default function EditPostContainer<T>(
	{
		progressValue,
		mode,
		title,
		children,
		nextText,
		onNext,
		isNextAvailable,
	}: CommonContainerProps<T>,
) {
	const history = useHistory()

	return (
		<Container>
			<ProgressHeader>
				{
					Number.isFinite(progressValue as number) && (
						<ProgressBar value={progressValue} />
					)
				}
				<ClickableCrossDark
					onClick={
						useCallback(() => {
							if (mode === 'edit') {
								history.goBack()
							} else {
								history.replace('jobBoard')
							}
						}, [mode, history])
					}
				/>
			</ProgressHeader>
			<HeaderText>
				<p>
					{{
						post: 'Post a Job',
						edit: 'Edit a Job',
					}[mode]}
				</p>
				<h1>{title}</h1>
				<Divider />
			</HeaderText>
			<ChildContainer>
			{children}
			</ChildContainer>
			<FooterContainer
				className={mode === 'post' ? '' : 'singleButton'}
			>
				{
					(mode === 'post')
						? (<>
							<BackButton
								onClick={() => history.goBack()}
							/>
							<GradientButton
								disabled={!isNextAvailable}
								text={nextText || 'Next'}
								onClick={() => {
									const nextRoute = onNext(null as any)
									if (nextRoute) {
										history.push({
											pathname: nextRoute,
											state: { mode },
										})
									}
								}}
							/>
						</>)
						: (
							<ConfirmButton
								disabled={!isNextAvailable}
								onClick={() => {
									onNext(null as any)
									history.goBack()
								}}
							>
								{mode === 'edit' ? 'Submit' : 'Edit'}
							</ConfirmButton>
						)
				}
			</FooterContainer>
		</Container>
	)
}
